/* global $ */

class WorksMV {
  constructor() {
    this.$class = $('.Hero-case').length ? $('.Hero-case') : $('.Hero--blog');
    this.$image = this.$class.find('.Image');
    this.isNote = $('.Hero-case').length ? false : true;

    // this.$classHeight = this.$class.outerHeight(); // ↓２つが不要ならこれも不要なので削除
    // this.$classInitialHeight = this.$classHeight; // 使っていないようなので削除
    // this.$classEndPosition = $(this).$classPosition + this.$classHeight; // 使っていないようなので削除
  }
  update(scrollY, windowH) {
    this.$classPosition = this.isNote
      ? this.$class.offset().top - 150
      : this.$class.offset().top;
    this.$scale = (1 - (this.$classPosition - scrollY * 0.1) / windowH) * 1;
    this.$opacity = 1 - (this.$classPosition - scrollY * 0.5) / windowH - 1;

    this.$image.css('transform', 'scale(' + this.$scale + ')');
    $('.PageMvCover').css(
      'background-color',
      'rgba(0,0,0,' + this.$opacity + ')'
    );
    $('.PageMvCover > span').css('opacity', this.$opacity * 2);
  }

  /*
  zoom() {
        this.$class.find('.Image').css('transform',  'scale(' + (this.$scale) + ')');
        $(".PageMvCover").css('background-color', 'rgba(0,0,0,' + this.$opacity + ')');
        $(".PageMvCover > span").css('opacity', this.$opacity * 2);
  }
  */
}

export default WorksMV;
